import * as React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { Grid } from "@mui/material";

export default function StandardSkeletoon({
  row = 4,
  col = 1,
  show = true,
  height = 30,
  escalier = false,
  m,
}) {
  return (
    <Grid display={show ? "flex" : "none"} m={m || 0}>
      {Array.from({ length: col }).map((_, colIdx) => (
        <Box
          key={colIdx}
          display={show ? "block" : "none"}
          m={0.5}
          width={"100%"}
        >
          {Array.from({ length: row }).map((_, rowIdx) => {
            let width = "100%";
            if (escalier) {
              if (rowIdx <= row/3) width = "100%";
              else if (rowIdx > row/3 && rowIdx <= 2 * row/3) width = "75%";
              else width = "50%";
            }
            return (
              <Skeleton
                key={rowIdx}
                animation="pulse"
                height={height}
                width={width || "100%"}
                style={{ marginBottom: 8 }}
              />
            );
          })}
        </Box>
      ))}
    </Grid>
  );
}
